import { Brightness2, WbSunny } from "@mui/icons-material";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useTheme } from "@mui/system";
import { setThemeType } from "@store/applicationLayout/actions";
import useTranslations from "containers/hooks/useLanguageHook";
import { useAppDispatch, useAppSelector } from "index";
import type { ApplicationState } from "store/index";

function ThemeSwitch({ collapsed }: { collapsed?: boolean }) {
  const type = useAppSelector((state: ApplicationState) => state.applicationLayout.type);
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const { t } = useTranslations();
  const icon = type === "dark" ? <WbSunny key={type} /> : <Brightness2 key={type} />;
  const onClick = () => dispatch(setThemeType(type === "dark" ? "light" : "dark"));

  return (
    <ListItem key={t.Options.SwitchTheme} disablePadding sx={{ display: "block" }}>
      <ListItemButton
        sx={{
          minHeight: 48,
          justifyContent: "initial",
          px: 2.5,
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.dark,
            fontWeight: 900,
          },
        }}
        onClick={onClick}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: 3,
            justifyContent: "center",
          }}
        >
          {icon}
        </ListItemIcon>
        <ListItemText primary={t.Options.SwitchTheme} sx={{ opacity: collapsed ? 1 : 0 }} />
      </ListItemButton>
    </ListItem>
  );
}

export default ThemeSwitch;
